<template>
  <div class="CRMOrders">
    <b-container fluid>
      <div class="top-row">
        <span class="top-row-name">CRM Orders</span>
        <b-button class="top-row-button" variant="success" @click="createOrder">Add</b-button>
        <b-button v-if="user.role == 'admin'" class="top-row-button" variant="success" v-b-modal.crm-report >Report</b-button>
        <b-button v-if="this.user.name == 'Rick'" class="top-row-button" variant="warning" @click="testFunction">Test Function</b-button>
        <b-button v-if="this.user.name == 'Rick'" class="top-row-button" variant="warning" @click="testFunctionElastic">Test Function Elastic</b-button>
      </div>

      <b-tabs v-model="tab_index">
        <b-tab title="Basic" title-link-class="text-success" @click="resetOrderFields">
          <div class="mt-2 search-bar">
            <b-input-group>
              <b-form-input
                type="text"
                v-model="searchbar_content"
                class="form-control"
                placeholder="Type to search"
              ></b-form-input>
              <b-input-group-append>
                <b-button variant="outline-success" @click="basic_search">Search</b-button>
                <b-button variant="outline-success" @click="cleanFilterInfo">
                  <b-icon icon="x-circle" variant="success"></b-icon>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </b-tab>
        <b-tab :variant="advanced_search_disabled ? 'success' : 'secondary '" :disabled="advanced_search_disabled" title="Advanced" title-link-class="text-success" @click="advanced_clicked">
          <b-row class="mt-2">
            <b-col>
              <label class="m-0" for="advanced-inline-form-input-invoice-number">Invoice #</label>
              <b-form-input
                :disabled="tableIsBusy" 
                v-model="advanced_filter_criteria_invoice_number"
                class="mb-2 mr-sm-2 mb-sm-0"
                ></b-form-input>
            </b-col>
            <!-- <b-col>
              <label for="advanced-inline-form-input-cemetery">Sales</label>
              <b-form-select 
                v-model="advanced_filter_criteria_sales" 
                :options="salesNames"
                class="mb-2 mr-sm-2 mb-sm-0"
                ></b-form-select>
            </b-col> -->

            <!-- <b-col>
              <label class="m-0" for="advanced-inline-form-input-first-name">First Name</label>
              <b-form-input
                :disabled="tableIsBusy" 
                v-model="advanced_filter_criteria_first_name" 
                class="mb-2 mr-sm-2 mb-sm-0"
                ></b-form-input>
            </b-col>

            <b-col>
              <label class="m-0" for="advanced-inline-form-input-last-name">Last Name</label>
              <b-form-input
                :disabled="tableIsBusy" 
                v-model="advanced_filter_criteria_last_name" 
                class="mb-2 mr-sm-2 mb-sm-0"
                ></b-form-input>
            </b-col> -->
            
            <b-col>
              <label class="m-0" for="advanced-inline-form-input-customer-name">C/Name</label>
              <b-form-input
                :disabled="tableIsBusy" 
                v-model="advanced_filter_criteria_customer_name" 
                class="mb-2 mr-sm-2 mb-sm-0"
                ></b-form-input>
            </b-col>

            <b-col>
              <label class="m-0" for="advanced-inline-form-input-style">Style</label>
              <b-form-select 
                :disabled="tableIsBusy" 
                v-model="advanced_filter_criteria_style" 
                :options="selectOptions.jobStyles"
                class="mb-2 mr-sm-2 mb-sm-0"
                placeholder="Style"
                ></b-form-select>
            </b-col>
            <b-col>
              <label class="m-0" for="advanced-inline-form-input-cemetery">Cemetery</label>
              <b-form-select
                :disabled="tableIsBusy"  
                v-model="advanced_filter_criteria_cemetery" 
                :options="selectOptions.cemeteries"
                class="mb-2 mr-sm-2 mb-sm-0"
                ></b-form-select>
            </b-col>
            <b-col>
              <label class="m-0" for="inline-form-input-section">Section</label>
              <b-form-input
                :disabled="tableIsBusy" 
                v-model="advanced_filter_criteria_section"
                id="inline-form-input-section"
                class="mb-2 mr-sm-2 mb-sm-0"
              ></b-form-input>
            </b-col>
            <b-col>
              <label class="m-0" for="inline-form-input-row">Row</label>
              <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                <b-form-input 
                  :disabled="tableIsBusy" 
                  id="inline-form-input-row"
                  v-model="advanced_filter_criteria_row"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col>
              <label class="m-0" for="inline-form-input-grave">Grave</label>
              <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                <b-form-input 
                  :disabled="tableIsBusy" 
                  id="inline-form-input-grave"
                  v-model="advanced_filter_criteria_grave"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col>
              <label class="m-0" for="inline-form-input-container">Container#</label>
              <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                <b-form-input 
                  :disabled="tableIsBusy" 
                  id="inline-form-input-container"
                  v-model="advanced_filter_criteria_container"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col class="text-center">
              <hr class="mb-1">
              <b-button :disabled="tableIsBusy" style="width:100%" variant="success" @click="advanced_search">Search</b-button>
            </b-col>
            <b-col class="text-center">
              <hr class="mb-1">
              <b-button :disabled="tableIsBusy" style="width:100%" @click="clear_advanced_search">Clear</b-button>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>

      <div class="mt-2">
        <b-pagination
          variant="success"
          v-model="currentPage"
          :page="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="my-table"></b-pagination>
      </div>

      <div>
        <b-checkbox
          v-if="searchMode == 'basic'"
          v-model="showClosedOrders"
          :value=true
          :unchecked-value=false
        >Show closed orders</b-checkbox>
      </div>

      <b-table
        bordered
        pointer
        responsive
        hover
        @row-clicked="tableRowClickHandler"
        :fields="orderFields"
        :filter="crmOrdersFilterCriteria"
        :filter-included-fields="filterOn"
        :items="displayedOrders"
        :per-page="perPage"
        :current-page="currentPage"
        :busy="tableIsBusy"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        small
      >

        <template #cell(invoiceNumber)="row">
          <div style="max-width: 120px;">
            {{ row.item.invoiceNumber }}
          </div>
        </template>

        <template #cell(customerLastName)="row">
          <div style="max-width: 100px;">
            {{ row.item.customerLastName }}
          </div>
        </template>

        <template #cell(cemetery)="row">
          <div class="table-text" style="max-width: 120px;">
            {{ row.item.cemetery }}
          </div>
        </template>

        <template #cell(style)="row">
          <div>
            {{ row.item.style }}
          </div>
        </template>

        <template #cell(foundation)="row">
          <div class="table-text" style="max-width: 200px;">
            {{ row.item.foundation }}
          </div>
        </template>

        <template #cell(section)="row">
          <div class="table-text" style="max-width: 120px;">
            {{ row.item.section }}
          </div>
        </template>

        <template #head(invoiceDate)="data">
          <div style="max-width: 60px">{{data.label}}</div>
        </template>
      
        <template #cell(invoiceDate)="row">
          <div style="max-width: 80px">
            {{ formatDate(row.item.invoiceDate) }}
          </div>
        </template>

        <template #head(orderDate)="data">
          <div style="max-width: 60px">{{data.label}}</div>
        </template>

        <template #cell(orderDate)="row">
          <div style="max-width: 112px">
            {{ formatDate(row.item.orderDate) }}
          </div>
        </template>

        <template #cell(orderingCrateNumber)="row">
          <div style="max-width: 112px">
            <span v-if="row.item.orderingContainerNumber1.toLowerCase().includes(advanced_filter_criteria_container.toLowerCase())">{{ row.item.orderingCrateNumber1 }}</span>
            <span v-if="row.item.orderingContainerNumber2.toLowerCase().includes(advanced_filter_criteria_container.toLowerCase())">{{ row.item.orderingCrateNumber2 }}</span>
            <span v-if="row.item.orderingContainerNumber3.toLowerCase().includes(advanced_filter_criteria_container.toLowerCase())">{{ row.item.orderingCrateNumber3 }}</span>
          </div>
        </template>

        <!-- Shrink the name of columns -->
        <template #head(orderingInscriptionToFactory)="data">
          <div style="max-width: 80px;">
            {{ data.label }}
          </div>
        </template>

        <template #head(totalAmount)="data">
          <div style="max-width: 80px">{{data.label}}</div>
        </template>

        <template #head(outstandingAmount)="data">
          <div style="max-width: 80px">{{data.label}}</div>
        </template>

        <template #table-busy>
          <div class="text-center text-success my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
      
      </b-table>

      <div class="text-centre" v-if="noMatchedRecord">No Matched Record</div>
    </b-container>

    <b-modal size="lg" id="add-order" title="New Order" hide-footer>
      <b-form @submit.prevent="createOrderTask">
        <b-row>
          <b-col cols="4" v-for="item in createOrderFormInputs" :key="item.key">
            <label :for="`new-order-input-${item.key}`">{{item.label}}<span style="color: red" v-if="item.mandatory">*</span></label>
            <b-form-input v-if="item.form_type == 'text-input'" :id="`new-order-input-${item.key}`" :type="item.type" v-model="newOrder[item.key]" :required="item.mandatory" min="0.00"></b-form-input>
            <span v-if="item.form_type == 'text-input-list'">
              <b-form-input :id="`new-order-input-${item.key}`" :type="item.type" v-model="newOrder[item.key]" :required="item.mandatory" :list="item.listName" min="0.00"></b-form-input>
              <datalist :id="item.listName">
                <option v-for="(option, index) in dataLists[item.listName]" :key="item.label + index">{{ option }}</option>
              </datalist>
            </span>
            <b-form-select v-if="item.form_type == 'select'"
              :id="`new-order-input-${item.key}`"
              v-model="newOrder[item.key]" 
              :required="item.mandatory"
              :options="selectOptions[item.options]"
            ></b-form-select>
            <b-form-datepicker v-if="item.form_type == 'datepicker'"
              :id="`new-order-input-${item.key}`"
              v-model.trim="newOrder[item.key]" 
              :required="item.mandatory"
              today-button
              reset-button
              close-button
            ></b-form-datepicker>
          </b-col>
          <b-col cols="12">
            <label for="new-order-description">Description<span style="color: red">*</span></label>
            <b-form-textarea
              id="new-order-description"
              v-model="newOrder.description"
              rows="3"
              max-rows="6"
              :required="true"
            ></b-form-textarea>
          </b-col>
        </b-row>
        <div class="mt-4 modal-footer">
          <b-button @click="hideModal('add-order')"> Cancel </b-button>
          <b-button class="ml-1" variant="success" type="submit">
            <span v-if="!isCreating">Create</span>
            <span v-if="isCreating">
              <b-spinner small type="grow"></b-spinner>
              Create...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="crm-report" title="CRM Report" hide-footer size="xl">
      <b-form inline>
        <label for="" class="mr-2">Date From: </label>
        <b-form-datepicker :date-format-options="{ year: 'numeric', month: 'short', day: 'numeric'}" class="mr-2" id="invoice-date-from" v-model="crmReportInvoiceDateFrom"></b-form-datepicker>
        <label for="" class="mr-2">Date To: </label>
        <b-form-datepicker :date-format-options="{ year: 'numeric', month: 'short', day: 'numeric'}" id="invoice-date-to" class="mr-2" v-model="crmReportInvoiceDateTo"></b-form-datepicker>
        <label for="report-type-options" class="mr-2">Type: </label>
        <b-form-select class="mr-2" id="report-type-options" :options="reprotTypeOptions" v-model="crmReportType"></b-form-select>
        <b-button variant="success" @click="crmReportSearch">Search</b-button>
      </b-form>
      <b-table
        class="mt-3"
        pointer
        responsive
        striped
        hover
        :sort-by.sync="crmReportSearchResultsortBy"
        @row-clicked="crmReportSearchResultClickHandler"
        :fields="crmReportSearchResultItemsFields"
        :items="crmReportSearchResultItems"
      >
      </b-table>
    </b-modal>

    <b-modal id="crm-report-details" title="CRM Report Details" hide-footer size="xl">
      <b-table
        class="mt-3"
        pointer
        responsive
        striped
        hover
        @row-clicked="crmReportSearchDetailsClickHandler"
        :fields="crmReportSearchDetailsFields"
        :items="crmReportSearchDetailsItems"
      >
      </b-table>
    </b-modal>
  </div>
</template>

<script>
import firebase from "firebase/app";
import * as ElasticAppSearch from "@elastic/app-search-javascript";
//import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";

export default {
  data() {
    return {
      elasticClient: Object,
      elasticSearchFields: {
        invoicenumber: {},
        customerfirstname: {},
        customerlastname: {},
        deceasedname: {},
        style: {},
        salesName: {},
        cemetery: {},
        section: {},
        row: {},
        grave: {},
        orderingcontainernumber1: {},
        orderingcontainernumber2: {},
        orderingcontainernumber3: {},
      },
      elasticResultFields: {
        invoicenumber: { raw: {} },
        id: { raw: {} },
        customerlastname: { raw: {} },
        salesname: { raw: {} },
        invoicedate: { raw: {} },
        orderdate: { raw: {} },
        docketnumber: { raw: {} },
        orderinginscriptiontofactory: { raw: {} },
        orderingmanufacturer: { raw: {} },
        orderingcontainernumber1: { raw: {} },
        cemetery: { raw: {} },
        section: { raw: {} },
        style: { raw: {} },
        foundation: { raw: {} },
        totalamount: { raw: {} },
        outstandingamount: { raw: {} },
      },
      advanced_search_disabled: true,
      searchbar_content: "",
      noMatchedRecord: false,
      tab_index: 1,
      advanced_search_result: [],
      searchMode: "basic",
      allOrders: [],
      tableIsBusy: false,
      crmReportInvoiceDateFrom: "",
      crmReportInvoiceDateTo: "",
      crmReportType: "",
      crmReportItems: [],
      crmReportSearchResult: {},
      crmReportSearchResultItems: [],
      crmReportSearchResultItemsFields: [],
      crmReportSearchResultsortBy: "",
      crmReportSearchDetailsFields: [
        { key: "invoiceNumber", label: "Invoice #", sortable: true },
        { key: "customerLastName", label: "C/Name" },
        { key: "salesName", label: "sales" },
        { key: "invoiceDate", label: "Invoice Date", sortable: true },
        { key: "orderDate", label: "Order Date", sortable: true },
        { key: "orderingManufacturer", label: "Manufacturer"},
        { key: "orderingContainerNumber1", label: "Container #", sortable: true },
        { key: "cemetery", label: "Cemetery" },
        { key: "section", label: "Section" },
        { key: "totalAmount", label: "Total Amount" },
        { key: "outstandingAmount", label: "Outstanding Amount" },
      ],
      crmReportSearchDetailsItems: [],
      reprotTypeOptions: [
        'Funeral Service Provider',
        'Cemetery',
        'Sales',
        'Leadsource'
      ],
      showClosedOrders: false,
      filterOn: [
        'invoiceNumber',
        'customerLastName',
        'customerFirstName',
        'salesName',
        'invoiceDate',
        'orderDate',
        'cemetery',
        'style',
        'section',
        'phone',
      ],
      sortBy: "invoiceDate",
      sortDesc: true,
      showAllOrders: "",
      advanced_filter_criteria_invoice_number: "",
      advanced_filter_criteria_sales: "",
      advanced_filter_criteria_first_name: "",
      advanced_filter_criteria_last_name: "",
      advanced_filter_criteria_customer_name: "",
      advanced_filter_criteria_style: "",
      advanced_filter_criteria_cemetery: "",
      advanced_filter_criteria_section: "",
      advanced_filter_criteria_row: "",
      advanced_filter_criteria_grave: "",
      advanced_filter_criteria_container: "",
      viewedOrder: "",
      isCreating: false,
      displayedOrders: [],
      filtered_orders: [],
      orders: [],
      activeOrders: [],
      myOrders: [],
      perPage: 20,
      currentPage: 1,
      orderFields: [
        { key: "invoiceNumber", label: "Invoice #", sortable: true },
        { key: "customerLastName", label: "C/Name" },
        { key: "salesName", label: "sales" },
        { key: "invoiceDate", label: "Invoice Date", sortable: true },
        { key: "orderDate", label: "Order Date", sortable: true },
        { key: "docketNumber", label: "Docket #", sortable: false },
        { key: "orderingInscriptionToFactory", label: "Inscription to Factory" },
        { key: "orderingManufacturer", label: "Mfr."},
        { key: "orderingContainerNumber1", label: "Container#", sortable: true },
        { key: "cemetery", label: "Cemetery" },
        { key: "section", label: "Section" },
        { key: "style", label: "Style" },
        { key: "foundation", label: "Foundation" },
        { key: "totalAmount", label: "Total Amount" },
        { key: "outstandingAmount", label: "Outstanding Amount" },
      ],
      crmReportFields: [
        { key: "invoiceNumber", label: "Invoice #", sortable: true },
        { key: "customerLastName", label: "C/Name" },
        { key: "salesName", label: "sales" },
        { key: "invoiceDate", label: "Invoice Date", sortable: true },
        { key: "orderDate", label: "Order Date", sortable: true },
        { key: "orderingManufacturer", label: "Manufacturer"},
        { key: "orderingContainerNumber1", label: "Container#"},
        { key: "cemetery", label: "Cemetery" },
        { key: "section", label: "Section" },
        { key: "totalAmount", label: "Total Amount" },
        { key: "outstandingAmount", label: "Outstanding Amount" },
      ],
      monthNames: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      filterCriteria: "",
      newOrder: {
        orderDate: "",
        docketNumber: "",
        address: "",
        ashlarDoneDate: "",
        ashlarInstaller: "",
        cemetery: "",
        comments: [],
        complaints: [],
        createDate: "",
        createDateTimestamp: null,
        creater: this.user,
        customerFirstName: "",
        customerLastName: "",
        customerTitle: "",
        deceasedName: "",
        description: "",
        email: "",
        emailHistories: [],
        fileHistories: [],
        files: [],
        finalPaymentDate: "",
        firstPaymentDate: "",
        foundation: "",
        funeralServiceProvider: "",
        grave: "",
        histories: [],
        id: "",
        inscriptionDoneDate: "",
        inscriptionInstaller: "",
        installationNote: "",
        installations: [],
        invoiceDate: "",
        invoiceNumber: "",
        invoiceTime: null,
        itemCode: "",
        leadSource: "",
        monumentDoneDate: "",
        monumentInstaller: "",
        orderingATA: "",
        orderingConfirmDate: "",
        orderingContainerNumber1: "",
        orderingContainerNumber2: "",
        orderingContainerNumber3: "",
        orderingCrateNumber1: "",
        orderingCrateNumber2: "",
        orderingCrateNumber3: "",
        orderingDispatchDate: "",
        orderingETA: "",
        orderingInscriptionToFactory: "",
        orderingManufacturer: "",
        orderingOrderDate: "",
        orderingStoreLocation: "",
        orderingUnloadStore: "",
        outstandingAmount: 0,
        phone: "",
        postcode: "",
        row: "",
        sales: null,
        salesName: this.user.name,
        secondPaymentDate: "",
        section: "",
        state: "",
        status: "active",
        style: "",
        suburb: "",
        totalAmount: 0,
      },
      createOrderFormInputs: [
        { key: "customerFirstName", label: "First Name", type: "text", form_type: "text-input", mandatory: true },
        { key: "customerLastName", label: "Last Name", type: "text", form_type: "text-input", mandatory: true },
        { key: "salesName", label: "Sales", type: "text", form_type: "select", options:'salesNames', mandatory: true},
        { key: "phone", label: "Phone", type: "text", form_type: "text-input", mandatory: false },
        { key: "email", label: "Email", type: "text", form_type: "text-input", mandatory: false },
        { key: "address", label: "Address", type: "text", form_type: "text-input", mandatory: false },
        { key: "suburb", label: "Suburb", type: "text", form_type: "text-input-list", listName: "suburbList", mandatory: true },
        { key: "state", label: "State", type: "text", form_type: "text-input", mandatory: false },
        { key: "postcode", label: "Postcode", type: "text", form_type: "text-input", mandatory: false },
        { key: "deceasedName", label: "Deceased Name", type: "text", form_type: "text-input", mandatory: false },
        { key: "leadSource", label: "Lead Source", type: "text", form_type: "select", options:'leadSourceNames', mandatory: true },
        { key: "invoiceNumber", label: "Invoice Number", type: "text", form_type: "text-input", mandatory: true },
        { key: "invoiceDate", label: "Invoice Date", type: "text", form_type: "datepicker", mandatory: true },
        { key: "itemCode", label: "Item Code", type: "text", form_type: "text-input", mandatory: false },
        { key: "totalAmount", label: "Total Amount", type: "text", form_type: "text-input", mandatory: true },
        { key: "outstandingAmount", label: "Outstanding Amount", type: "text", form_type: "text-input", mandatory: true },
        { key: "firstPaymentDate", label: "First Payment Date", type: "text", form_type: "datepicker", mandatory: false },
        { key: "cemetery", label: "Cemetery", type: "text", form_type: "select", options:'cemeteries', mandatory: false },
        { key: "foundation", label: "Foundation", type: "text", form_type: "select", options:'foundations', mandatory: false },
        { key: "funeralServiceProvider", label: "Funeral Service", type: "text", form_type: "select", options:'funeralServiceProviderNames', mandatory: true },
        { key: "section", label: "Section", type: "text", form_type: "text-input-list", listName: "sectionList", mandatory: false },
        { key: "row", label: "Row", type: "text", form_type: "text-input", mandatory: false },
        { key: "grave", label: "Grave", type: "text", form_type: "text-input", mandatory: false },
        { key: "style", label: "Style", type: "text", form_type: "select", options:'jobStyles', mandatory: false },
        // { key: "description", label: "Description", type: "text", mandatory: true },
      ],
    };
  },
  props: {
    user: null,
    crmOrdersFilterCriteria: String,
    today: String,
    dataLists: Object,
    selectOptions: Object,
    sales: Array,
    CRMAdvancedSearchInfo: Object,
  },
  methods: {
    basic_search() {
      this.filterCriteria = this.searchbar_content;
    },
    crmReportSearch() {
      if (this.crmReportInvoiceDateFrom.legnth == 0 
        || this.crmReportInvoiceDateTo.length == 0 
        || this.crmReportType.length == 0) 
      {
        alert("Need Date From/To and Reprot Type");
        return;
      }

      let start = new Date(this.crmReportInvoiceDateFrom)
      let to = new Date(this.crmReportInvoiceDateTo)

      if (this.crmReportType == 'Funeral Service Provider') {
        this.crmReportSearchResultsortBy = 'name';
      }

      firebase
        .firestore()
        .collection("crm_orders_simplified")
        .where('invoiceTime', '>', start)
        .where('invoiceTime', '<', to)
        .orderBy("invoiceTime", "desc")
        .get()
        .then((collection) => {
          var rows = collection.docs.map(doc => doc.data());
          console.log(rows);
          this.crmReportSearchResult = {};
          if (this.crmReportType == 'Funeral Service Provider') {
            this.crmReportSearchResultItemsFields = [
              { key: "name", label: "Provider"},
              { key: "count", label: "Count"},
            ];
            
            rows.forEach((e) => {
              if (this.crmReportSearchResult[e.funeralServiceProvider] == null) {
                this.crmReportSearchResult[e.funeralServiceProvider] = [];
              }
              this.crmReportSearchResult[e.funeralServiceProvider].push(e);
            });
          } else if (this.crmReportType == 'Cemetery') {
            this.crmReportSearchResultItemsFields = [
              { key: "name", label: "Cemetery"},
              { key: "count", label: "Count"},
            ];
            
            rows.forEach((e) => {
              if (this.crmReportSearchResult[e.cemetery] == null) {
                this.crmReportSearchResult[e.cemetery] = [];
              }
              this.crmReportSearchResult[e.cemetery].push(e);
            });
          } else if (this.crmReportType == 'Sales') {
            this.crmReportSearchResultItemsFields = [
              { key: "name", label: "Sales"},
              { key: "count", label: "Count"},
            ];
            
            rows.forEach((e) => {
              if (this.crmReportSearchResult[e.salesName] == null) {
                this.crmReportSearchResult[e.salesName] = [];
              }
              this.crmReportSearchResult[e.salesName].push(e);
            });
          } else if (this.crmReportType == 'Leadsource') {
            this.crmReportSearchResultItemsFields = [
              { key: "name", label: "Leadsource"},
              { key: "count", label: "Count"},
            ];
            
            rows.forEach((e) => {
              if (this.crmReportSearchResult[e.leadSource] == null) {
                this.crmReportSearchResult[e.leadSource] = [];
                console.log(e);
              }
              this.crmReportSearchResult[e.leadSource].push(e);
            });
          }

          this.crmReportSearchResultItems = [];
          //console.log(this.crmReportSearchResult);
          for ( const e in this.crmReportSearchResult) {
            this.crmReportSearchResultItems.push({
              name: e,
              count: this.crmReportSearchResult[e].length
            })
          }

        });
    },
    resetOrderFields() {
      this.searchMode = "basic";

      this.orderFields = [
        { key: "invoiceNumber", label: "Invoice #", sortable: true },
        { key: "customerLastName", label: "C/Name" },
        { key: "salesName", label: "sales" },
        { key: "invoiceDate", label: "Invoice Date", sortable: true },
        { key: "orderDate", label: "Order Date", sortable: true },
        { key: "docketNumber", label: "Docket #", sortable: false },
        { key: "orderingInscriptionToFactory", label: "Inscription to Factory" },
        { key: "orderingManufacturer", label: "Mfr."},
        { key: "orderingContainerNumber1", label: "Container#", sortable: true },
        { key: "cemetery", label: "Cemetery" },
        { key: "section", label: "Section" },
        { key: "style", label: "Style" },
        { key: "foundation", label: "Foundation" },
        { key: "totalAmount", label: "Total Amount" },
        { key: "outstandingAmount", label: "Outstanding Amount" },
      ];

      // this.clear_advanced_search();
      if (!this.showClosedOrders) {
        this.displayedOrders = this.activeOrders;
      } else {
        this.showClosedOrders = false;
        this.showClosedOrders = true;
        if (this.displayedOrders.length == 0 ) {
          this.displayedOrders = this.orders;
        }
      }
      this.filterCriteria = this.searchbar_content;
    },
    advanced_clicked() {
      this.displayedOrders = this.advanced_search_result;

      // const connector = new AppSearchAPIConnector({
      //   searchKey: "search-z5hckd415fojgcwp5ydfus6c",
      //   engineName: "crm-orders-search",
      //   endpointBase: "https://jsm-crm-search.ent.australia-southeast1.gcp.elastic-cloud.com"
      // });

      // console.log(connector);

      // const config = {
      //   debug: true,
      //   alwaysSearchOnInitialLoad: true,
      //   apiConnector: connector,
      //   hasA11yNotifications: true,
      //   searchQuery: {
      //     result_fields: {
      //       id: "",
      //     }
      //   }
      // };

      
      // console.log(config);

      // let url = "https://jsm-crm-search.ent.australia-southeast1.gcp.elastic-cloud.com/api/as/v1/engines/crm-orders-search/documents";
      // let token = "private-9jwekwabd8k5ewjjn7o368nu";
      // "Authorization": "Bearer " + token
      // let config = {
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   auth: {
      //     username: "elastic", 
      //     password: "R6g2rXPy7hoqy8Dop672mAOQ"
      //   }
      // }

      // let data = {
      //   "query": "DA19997"
      // }
      
      // axios.get(url, {}, {auth: {
      //     username: "elastic", 
      //     password: "R6g2rXPy7hoqy8Dop672mAOQ"
      //   }})
      //   .then(response => {
      //     console.log(response);
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });

      this.filterCriteria = "";
      this.displayedOrders = this.advanced_search_result;
      this.searchMode = "advanced";
      this.crmOrdersFilterCriteria = "";
      this.tableIsBusy = true;

      // console.log(this.advanced_search_result.length);

      // if (this.advanced_search_result.length > 0) {
      //   this.tableIsBusy = false;
      //   return;
      // }

      if (this.user.role == "sales") {
        firebase
          .firestore()
          .collection("crm_orders_simplified")
          .onSnapshot((collection) => {
            this.allOrders = collection.docs.map((doc) => doc.data());
            setTimeout(() => {this.tableIsBusy = false;}, "4000");
            return;
          }, (error) => {
            alert('The read failed: ' + error.name);
            this.tableIsBusy = false;
          });
          console.log('pulled');
      } else if (this.user.role == "admin") {
        firebase
          .firestore()
          .collection("crm_orders_simplified")
          .onSnapshot((collection) => {
            this.orders = collection.docs.map((doc) => doc.data());
            console.log(this.orders.length);
            setTimeout(() => {this.tableIsBusy = false;}, "4000");
          }, (error) => {
            alert('The read failed: ' + error.name);
            this.tableIsBusy = false;
          });
        console.log('pulled');
      } 
      
    },
    formatDate(dateString) {
      if (!dateString || dateString == "") return "";
      const ymd = dateString.split("-");
      const monthString = ymd[1].charAt(0) == "0" ? ymd[1].slice(1) : ymd[1];
      return ymd[2] + "-" + this.monthNames[parseInt(monthString) - 1] + '-' + ymd[0].slice(-2);
    },
    tableRowClickHandler(item) {
      // console.log(item);
      this.$emit("CRMViewOrder", {id: item.id, from: 'CRMOrders'});
      this.$emit("CRMAdvancedSearchInfo", {
        advanced_search_result: this.advanced_search_result, 
        advanced_filter_criteria_invoice_number: this.advanced_filter_criteria_invoice_number,
        advanced_filter_criteria_sales: this.advanced_filter_criteria_sales,
        advanced_filter_criteria_customer_name: this.advanced_filter_criteria_customer_name,
        advanced_filter_criteria_style: this.advanced_filter_criteria_style,
        advanced_filter_criteria_cemetery: this.advanced_filter_criteria_cemetery,
        advanced_filter_criteria_section: this.advanced_filter_criteria_section,
        advanced_filter_criteria_row: this.advanced_filter_criteria_row,
        advanced_filter_criteria_grave: this.advanced_filter_criteria_grave,
        advanced_filter_criteria_container: this.advanced_filter_criteria_container,
        searchMode: this.searchMode,
        })
      if (this.user.name == "Rick") console.log(item);
    },
    crmReportSearchResultClickHandler(item) {
      this.crmReportSearchDetailsItems = this.crmReportSearchResult[item.name];
      this.showModal('crm-report-details');
    },
    crmReportSearchDetailsClickHandler(item) {
      this.viewedOrder = Object.assign({}, item);
      this.$emit("CRMViewOrder", {item: Object.assign({}, item), from: 'CRMOrders'});
    },
    cleanFilterInfo() {
      this.filterCriteria = "";
      this.searchbar_content = "";
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    createOrder() {
      this.showModal('add-order');
    },
    createOrderTask() {
      this.isCreating = true;
      const newOrderRef = firebase
        .firestore()
        .collection("crm_orders")
        .doc();

      this.newOrder.id = newOrderRef.id;

      const newSimplifiedOrderRef = firebase
        .firestore()
        .collection("crm_orders_simplified")
        .doc(this.newOrder.id);

      if (this.newOrder.invoiceDate != null && this.newOrder.invoiceDate.length > 0) {
        this.newOrder.invoiceTime = new Date(this.newOrder.invoiceDate);
      }
      
      this.newOrder.sales = this.sales[this.selectOptions.salesNames.indexOf(this.newOrder.salesName)];
      this.newOrder.createDate = this.today;
      this.newOrder.createDateTimestamp = new Date(this.today);
      // this.newOrder.orderDate = this.today;
      if (this.newOrder.suburb.length > 0) this.newOrder.suburb = this.newOrder.suburb[0].toUpperCase() + this.newOrder.suburb.slice(1);
      if (this.newOrder.section.length > 0) this.newOrder.section = this.newOrder.section[0].toUpperCase() + this.newOrder.section.slice(1);
      const tempOrder = Object.assign({}, this.newOrder);
      delete tempOrder.histories;
      tempOrder.editor = this.user;
      tempOrder.editDate = this.today;
      this.newOrder.histories.push(tempOrder);

      let newSimplifiedOrder = {
        id: this.newOrder.id,
        cemetery: this.newOrder.cemetery, 
        customerFirstName: this.newOrder.customerFirstName, 
        customerLastName: this.newOrder.customerLastName, 
        deceasedName: this.newOrder.deceasedName, 
        grave: this.newOrder.grave, 
        invoiceNumber: this.newOrder.invoiceNumber, 
        salesName: this.newOrder.salesName, 
        style: this.newOrder.style, 
        section: this.newOrder.section, 
        row: this.newOrder.row, 
        orderingContainerNumber1: this.newOrder.orderingContainerNumber1, 
        orderingContainerNumber2: this.newOrder.orderingContainerNumber2, 
        orderingContainerNumber3: this.newOrder.orderingContainerNumber3, 
        invoiceDate: this.newOrder.invoiceDate, 
        orderDate: this.newOrder.orderDate, 
        docketNumber: this.newOrder.docketNumber, 
        orderingInscriptionToFactory: this.newOrder.orderingInscriptionToFactory, 
        orderingManufacturer: this.newOrder.orderingManufacturer, 
        foundation: this.newOrder.foundation, 
        totalAmount: this.newOrder.totalAmount, 
        outstandingAmount: this.newOrder.outstandingAmount, 
        orderingStoreLocation: this.newOrder.id, 
        // orderingCrateNumber1: this.newOrder.id, 
        // orderingCrateNumber2: this.newOrder.id, 
        // orderingCrateNumber3: this.newOrder.id, 
        // description: this.newOrder.id, 
        status: this.newOrder.status,
        funeralServiceProvider: this.newOrder.funeralServiceProvider,
      };

      if (this.newOrder.invoiceTime) {
        newSimplifiedOrder.invoiceTime = this.newOrder.invoiceTime;
      }

      console.log(newSimplifiedOrder);

      newOrderRef.set(this.newOrder).then(() => {
        newSimplifiedOrderRef.set(newSimplifiedOrder);

        this.isCreating = false;
        this.hideModal("add-order");
        alert("Create successfully");

        if (!this.dataLists.suburbList.includes(this.newOrder.suburb) && this.newOrder.suburb != "") {
          this.dataLists.suburbList.push(this.newOrder.suburb);
          firebase.firestore().collection("datalists").doc("pMDl8MQ5rNsxrdK020ao")
            .set({suburbList: this.dataLists.suburbList},
              {merge: true});
        }

        if (!this.dataLists.suburbList.includes(this.newOrder.section) && this.newOrder.section != "") {
          this.dataLists.sectionList.push(this.newOrder.section)
          firebase.firestore().collection("datalists").doc("E3QYIcTtYWivCtJBoBSy")
            .set({sectionList: this.dataLists.sectionList},
            {merge: true});
        }

        this.viewedOrder = Object.assign({}, this.newOrder);
        this.$emit("CRMViewOrder", {id: this.newOrder.id, from: 'CRMOrders'});

        this.newOrder = {
          orderDate: "",
          docketNumber: "",
          address: "",
          ashlarDoneDate: "",
          ashlarInstaller: "",
          cemetery: "",
          comments: [],
          complaints: [],
          createDate: "",
          createDateTimestamp: null,
          creater: this.user,
          customerFirstName: "",
          customerLastName: "",
          customerTitle: "",
          deceasedName: "",
          description: "",
          email: "",
          emailHistories: [],
          fileHistories: [],
          files: [],
          finalPaymentDate: "",
          firstPaymentDate: "",
          foundation: "",
          funeralServiceProvider: "",
          grave: "",
          histories: [],
          id: "",
          inscriptionDoneDate: "",
          inscriptionInstaller: "",
          installationNote: "",
          installations: [],
          invoiceDate: "",
          invoiceNumber: "",
          invoiceTime: null,
          itemCode: "",
          leadSource: "",
          monumentDoneDate: "",
          monumentInstaller: "",
          orderingATA: "",
          orderingConfirmDate: "",
          orderingContainerNumber1: "",
          orderingContainerNumber2: "",
          orderingContainerNumber3: "",
          orderingCrateNumber1: "",
          orderingCrateNumber2: "",
          orderingCrateNumber3: "",
          orderingDispatchDate: "",
          orderingETA: "",
          orderingInscriptionToFactory: "",
          orderingManufacturer: "",
          orderingOrderDate: "",
          orderingStoreLocation: "",
          orderingUnloadStore: "",
          outstandingAmount: 0,
          phone: "",
          postcode: "",
          row: "",
          sales: null,
          salesName: this.user.name,
          secondPaymentDate: "",
          section: "",
          state: "",
          status: "active",
          style: "",
          suburb: "",
          totalAmount: 0,
        }
      });
    },
    editOrderTask() {
      this.viewedOrder.sales = this.sales[this.selectOptions.salesNames.indexOf(this.viewedOrder.salesName)];
      const tempOrder = Object.assign({}, this.viewedOrder);
      delete tempOrder.histories;
      tempOrder.editDate = this.today;
      this.viewedOrder.histories.push(tempOrder);
      // console.log(this.viewedOrder);
      firebase.firestore().collection("crm_orders").doc(this.viewedOrder.id)
        .set(this.viewedOrder,
          {merge: true})
        .then(() => {
          this.hideModal('view-order');
          alert("Modify successfully");
        });
    },
    advanced_search() {
      this.tableIsBusy = true;
      setTimeout(this.advanced_search_task, "1500");
      // let ref = firebase.firestore().collection("crm_orders");
      // if (this.advanced_filter_criteria_invoice_number.length > 0) {
      //   ref = ref.where("invoiceNumber", "==", this.advanced_filter_criteria_invoice_number);
      // }
      // ref
      //   .onSnapshot((collection) => {
      //   this.displayedOrders = collection.docs.map((doc) => doc.data());
      //   this.tableIsBusy = false;
      // });
    },
    advanced_search_task() {
      this.noMatchedRecord = false;
      
      var processed_orders = [];
      if (this.user.role == 'admin') {
        processed_orders = this.orders;
      } else {
        processed_orders = this.allOrders;
      }

      this.filtered_orders = [];
      console.log(processed_orders.length);
      for (var i = 0; i < processed_orders.length; i++) {
        // if (processed_orders[i].customerLastName == null ||
        //   processed_orders[i].style == null || 
        //   processed_orders[i].cemetery == null ||
        //   processed_orders[i].section == null ||
        //   processed_orders[i].row == null ||
        //   processed_orders[i].grave == null ||
        //   processed_orders[i].invoiceNumber == null ||
        //   processed_orders[i].orderingContainerNumber1 == null ||
        //   processed_orders[i].orderingContainerNumber2 == null ||
        //   processed_orders[i].orderingContainerNumber3 == null) {
        //     console.log(processed_orders[i]);
        //   }

        // if (typeof processed_orders[i].grave != "string") {
        //   console.log(processed_orders[i].grave);
        // }

        console.log(processed_orders[i]);

        if ((this.advanced_filter_criteria_invoice_number == "" || processed_orders[i].invoiceNumber.toLowerCase().includes(this.advanced_filter_criteria_invoice_number.toLowerCase()))
          && (this.advanced_filter_criteria_style == "" || processed_orders[i].style.toLowerCase().includes(this.advanced_filter_criteria_style.toLowerCase()))
          && (this.advanced_filter_criteria_cemetery == "" || processed_orders[i].cemetery.toLowerCase().includes(this.advanced_filter_criteria_cemetery.toLowerCase()))
          && (this.advanced_filter_criteria_section == "" || processed_orders[i].section.toLowerCase().includes(this.advanced_filter_criteria_section.toLowerCase()))
          && (this.advanced_filter_criteria_row == "" || processed_orders[i].row.toLowerCase().includes(this.advanced_filter_criteria_row.toLowerCase()))
          && (this.advanced_filter_criteria_grave == "" || processed_orders[i].grave.toLowerCase().includes(this.advanced_filter_criteria_grave.toLowerCase()))
          && (this.advanced_filter_criteria_customer_name == "" 
              || processed_orders[i].customerFirstName.concat(processed_orders[i].customerLastName).toLowerCase().includes(this.advanced_filter_criteria_customer_name.toLowerCase().replace(/\s/g, ''))
              || processed_orders[i].deceasedName.toLowerCase().includes(this.advanced_filter_criteria_customer_name.toLowerCase()))
          && (this.advanced_filter_criteria_container == "" || processed_orders[i].orderingContainerNumber1.toLowerCase().includes(this.advanced_filter_criteria_container.toLowerCase())
              || processed_orders[i].orderingContainerNumber2.toLowerCase().includes(this.advanced_filter_criteria_container.toLowerCase())
              || processed_orders[i].orderingContainerNumber3.toLowerCase().includes(this.advanced_filter_criteria_container.toLowerCase())
          ))
        {
          // console.log('new order: ' + this.orders[i].invoiceNumber);
          // console.log(processed_orders[i]);
          // console.log("'" + processed_orders[i].customerFirstName.concat(processed_orders[i].customerLastName).toLowerCase());
          // console.log(processed_orders[i].deceasedName.toLowerCase() + "'");
          this.filtered_orders.push(processed_orders[i]);
        }
      }
      // console.log(this.filtered_orders);
      this.displayedOrders = this.filtered_orders;
      this.advanced_search_result = this.filtered_orders;
      if (this.displayedOrders.length == 0) {
        this.noMatchedRecord = true;
      }

      if (this.advanced_filter_criteria_container.length > 0) {
        this.orderFields = [
          { key: "salesName", label: "Sales"},
          { key: "orderingStoreLocation", label: "Store Location" },
          { key: "orderingCrateNumber", label: "Crate Number" },
          { key: "invoiceNumber", label: "Invoice #"},
          { key: "customerFirstName", label: "First Name"},
          { key: "customerLastName", label: "Last Name"},
          { key: "description", label: "Description"},
        ];
      }

      console.log("advanced_search");
      this.tableIsBusy = false;
    },
    clear_advanced_search() {
      this.noMatchedRecord = false;

      this.advanced_search_result = [];
      this.advanced_filter_criteria_customer_name = "";
      this.advanced_filter_criteria_sales = "";
      this.advanced_filter_criteria_style = "";
      this.advanced_filter_criteria_cemetery = "";
      this.advanced_filter_criteria_section = "";
      this.advanced_filter_criteria_row = "";
      this.advanced_filter_criteria_grave = "";
      this.advanced_filter_criteria_invoice_number = "";
      this.advanced_filter_criteria_container = "";
      this.displayedOrders = [];
      this.orderFields = [
        { key: "invoiceNumber", label: "Invoice #", sortable: true },
        { key: "customerLastName", label: "C/Name" },
        { key: "salesName", label: "sales" },
        { key: "invoiceDate", label: "Invoice Date", sortable: true },
        { key: "orderDate", label: "Order Date", sortable: true },
        { key: "docketNumber", label: "Docket #", sortable: false },
        { key: "orderingInscriptionToFactory", label: "Inscription to Factory" },
        { key: "orderingManufacturer", label: "Mfr."},
        { key: "orderingContainerNumber1", label: "Container#", sortable: true },
        { key: "cemetery", label: "Cemetery" },
        { key: "section", label: "Section" },
        { key: "style", label: "Style" },
        { key: "foundation", label: "Foundation" },
        { key: "totalAmount", label: "Total Amount" },
        { key: "outstandingAmount", label: "Outstanding Amount" },
      ]
    },
    testFunctionElastic() {
      var client = ElasticAppSearch.createClient({
        searchKey: "search-z5hckd415fojgcwp5ydfus6c",
        endpointBase: "https://jsm-crm-search.ent.australia-southeast1.gcp.elastic-cloud.com",
        engineName: "crm-orders-search"
      });

      let search_fields = {
        invoicenumber: {},
        customerfirstname: {},
        customerlastname: {},
        deceasedname: {},
        salesname: {},
        style: {},
        cemetery: {},
        section: {},
        row: {},
        grave: {},
        orderingcontainernumber1: {},
        orderingcontainernumber2: {},
        orderingcontainernumber3: {},
      };

      let result_fields = {
        invoicenumber: { raw: {} },
        id: { raw: {} },
        customerlastname: { raw: {} },
        salesname: { raw: {} },
        invoicedate: { raw: {} },
        orderdate: { raw: {} },
        docketnumber: { raw: {} },
        orderinginscriptiontofactory: { raw: {} },
        orderingmanufacturer: { raw: {} },
        orderingcontainernumber1: { raw: {} },
        cemetery: { raw: {} },
        section: { raw: {} },
        style: { raw: {} },
        foundation: { raw: {} },
        totalamount: { raw: {} },
        outstandingamount: { raw: {} },
      };

      // var invoiceNumOption = {
      //   search_fields: { invoiceNumber: {} },
      //   result_fields: result_fields
      // };
      // var customerNameOption = {
      //   search_fields: { 
      //     customerFirstName: {},
      //     customerLastName: {},
      //     deceasedName: {}
      //   },
      //   result_fields: result_fields
      // };
      // var styleOption = {
      //   search_fields: { style: {} },
      //   result_fields: result_fields
      // };
      // var cemeteryOption = {
      //   search_fields: { cemetery: {} },
      //   result_fields: result_fields
      // };
      // var sectionOption = {
      //   search_fields: { section: {} },
      //   result_fields: result_fields
      // };
      // var rowOption = {
      //   search_fields: { row: {} },
      //   result_fields: result_fields
      // };
      // var graveOption = {
      //   search_fields: { grave: {} },
      //   result_fields: result_fields
      // };
      // var containerNumberOption = {
      //   search_fields: { orderingContainerNumber1: {} },
      //   result_fields: result_fields
      // };

      // const query = {
      //   filters: {},
      //   result_fields: result_fields 
      // };

      // if (this.advanced_filter_criteria_invoice_number.length > 0) {
      //   query.filters.invoiceNumber = this.advanced_filter_criteria_invoice_number;
      // }

      // if (this.advanced_filter_criteria_customer_name.length > 0) {
      //   query.filters.customerLastName = this.advanced_filter_criteria_customer_name;
      // }

      // if (this.advanced_filter_criteria_style.length > 0) {
      //   query.filters.style = this.advanced_filter_criteria_style;
      // }

      // if (this.advanced_filter_criteria_cemetery.length > 0) {
      //   query.filters.cemetery = this.advanced_filter_criteria_cemetery;
      // }

      // if (this.advanced_filter_criteria_section.length > 0) {
      //   query.filters.section = this.advanced_filter_criteria_section;
      // }

      // if (this.advanced_filter_criteria_row.length > 0) {
      //   query.filters.row = this.advanced_filter_criteria_row;
      // }

      // if (this.advanced_filter_criteria_grave.length > 0) {
      //   query.filters.grave = this.advanced_filter_criteria_grave;
      // }

      // if (this.advanced_filter_criteria_container.length > 0) {
      //   query.filters.orderingContainerNumber1 = this.advanced_filter_criteria_container;
      // }

      let options = {
        search_fields: search_fields,
        result_fields: result_fields,
      }

      client
        .search(this.user.name , options)
        .then(resultList  => {
          resultList.forEach(resultList => {
            resultList.results.forEach(result => {
              console.log(result);
            });
          });
        })
        .catch(error => {
          console.log(`error: ${error}`);
        });
    },
    testFunction() {
      /*
      var client = ElasticAppSearch.createClient({
        searchKey: "search-z5hckd415fojgcwp5ydfus6c",
        endpointBase: "https://jsm-crm-search.ent.australia-southeast1.gcp.elastic-cloud.com",
        engineName: "crm-orders-search"
      });

      var options = {
        search_fields: { invoicenumber: {} },
        result_fields: { id: { raw: {} }, invoicenumber: { raw: {} } }
      };

      client
        .search("DA19997", options)
        .then(resultList => {
          resultList.results.forEach(result => {
            console.log(`id: ${result.getRaw("id")} raw: ${result.getRaw("invoicenumber")}`);
          });
        })
        .catch(error => {
          console.log(`error: ${error}`);
        });
      */

      firebase.firestore().collection("crm_orders")
      .get().then((collection) => {
        var rows = collection.docs.map(doc => doc.data());
        console.log(rows.length);
        rows.forEach((e) => {
          // if (e.invoiceDate != null && e.invoiceDate.length > 0 ) {
          //   let orderData = {
          //     invoiceTime: new Date(e.invoiceDate),
          //   }

          //   const orderref = firebase.firestore().collection("crm_orders").doc(e.id);
          //   orderref.set(orderData, {merge: true});
          // }

          var orderSimplifiedData = {
            // orderingCrateNumber1: e.orderingCrateNumber1? e.orderingCrateNumber1 : "",
            // orderingCrateNumber2: e.orderingCrateNumber2? e.orderingCrateNumber2 : "",
            // orderingCrateNumber3: e.orderingCrateNumber3? e.orderingCrateNumber3 : "",
            // orderingStoreLocation: e.orderingStoreLocation? e. orderingStoreLocation : "",
            // id: e.id? e.id : "",
            // cemetery: e.cemetery? e.cemetery : "", 
            // customerFirstName: e.customerFirstName? e.customerFirstName : "", 
            // customerLastName: e.customerLastName? e.customerLastName : "", 
            // deceasedName: e.deceasedName? e.deceasedName : "", 
            // invoiceNumber: e.invoiceNumber? e.invoiceNumber : "", 
            // salesName: e.salesName? e.salesName : "", 
            // style: e.style? e.style : "", 
            // section: e.section? e.section : "", 
            // orderingContainerNumber1: e.orderingContainerNumber1? e.orderingContainerNumber1 : "", 
            // orderingContainerNumber2: e.orderingContainerNumber2? e.orderingContainerNumber2 : "", 
            // orderingContainerNumber3: e.orderingContainerNumber3? e.orderingContainerNumber3 : "", 
            // invoiceDate: e.invoiceDate? e.invoiceDate : "", 
            // orderDate: e.orderDate? e.orderDate : "", 
            // docketNumber: e.docketNumber? e.docketNumber : "", 
            // orderingInscriptionToFactory: e.orderingInscriptionToFactory? e.orderingInscriptionToFactory : "", 
            // orderingManufacturer: e.orderingManufacturer? e.orderingManufacturer : "", 
            // foundation: e.foundation? e.foundation : "", 
            // totalAmount: e.totalAmount? e.totalAmount : "", 
            // outstandingAmount: e.outstandingAmount? e.outstandingAmount : "", 
            // status: e.status? e.status : "", 
            // row: e.row? e.row : "", 
            // grave: e.grave? e.grave : "",
            // funeralServiceProvider: e.funeralServiceProvider? e.funeralServiceProvider : "",
            // invoiceTime: e.invoiceTime? e.invoiceTime : "",
            // orderingCrateNumber1: e.orderingCrateNumber1? e.orderingCrateNumber1 : "",
            // orderingCrateNumber2: e.orderingCrateNumber2? e.orderingCrateNumber2 : "",
            // orderingCrateNumber3: e.orderingCrateNumber3? e.orderingCrateNumber3 : "",
            leadSource: e.leadSource? e.leadSource : "",
          };

          // const orderref = firebase.firestore().collection("crm_orders").doc(e.id);
          // orderref.set(orderData, {merge: true});

          const order_simplified_ref = firebase.firestore().collection("crm_orders_simplified").doc(e.id);
          order_simplified_ref.set(orderSimplifiedData, {merge: true});

          console.log("Uploaded");
        })
      });
    },
  },
  computed: {
    rows: function() {
      if (this.displayedOrders.length == 0) {
        return 100;
      } else {
        return this.displayedOrders.length;
      }
    },
  },
  watch: {
    filterCriteria(newFilterCriteria) {
      this.$emit("changeCrmOrdersFilterCriteria", newFilterCriteria);
    },
    showAllOrders(newValue) {
      if(newValue == 'yes') {
        this.displayedOrders = this.orders;
      } else {
        this.displayedOrders = this.myOrders;
      }
    },
    showClosedOrders(newValue) {
      if (this.orders.length == 0) {
        this.tableIsBusy = true;
        if (this.user.role == 'admin') {
          firebase
            .firestore()
            .collection("crm_orders_simplified")
            .orderBy("invoiceNumber", "asc")
            .onSnapshot((collection) => {
              this.orders = collection.docs.map((doc) => doc.data());
              if(!newValue) {
                this.displayedOrders = this.activeOrders;
              } else {
                this.displayedOrders = this.orders;
              }
              console.log("showClosedOrders");
              this.tableIsBusy = false;
              return;
            }, (error) => {
              alert('The read failed: ' + error.name);
              return;
            });
        } else {
          firebase
            .firestore()
            .collection("crm_orders_simplified")
            .where("salesName", "==", this.user.name)
            .orderBy("invoiceNumber", "asc")
            .onSnapshot((collection) => {
              this.orders = collection.docs.map((doc) => doc.data());
              if(!newValue) {
                this.displayedOrders = this.activeOrders;
              } else {
                this.displayedOrders = this.orders;
              }
              console.log("showClosedOrders");
              this.tableIsBusy = false;
              return;
            }, (error) => {
              console.log('The read failed: ' + error.name);
              return;
            });
        }
      }

      if(!newValue) {
        this.displayedOrders = this.activeOrders;
      } else {
        this.displayedOrders = this.orders;
      }
    },
  },
  created() {
    this.elasticClient = ElasticAppSearch.createClient({
      searchKey: "search-z5hckd415fojgcwp5ydfus6c",
      endpointBase: "https://jsm-crm-search.ent.australia-southeast1.gcp.elastic-cloud.com",
      engineName: "crm-orders-search"
    });

    this.advanced_search_result = this.CRMAdvancedSearchInfo.advanced_search_result;
    this.advanced_filter_criteria_invoice_number = this.CRMAdvancedSearchInfo.advanced_filter_criteria_invoice_number;
    this.advanced_filter_criteria_sales = this.CRMAdvancedSearchInfo.advanced_filter_criteria_sales;
    this.advanced_filter_criteria_customer_name = this.CRMAdvancedSearchInfo.advanced_filter_criteria_customer_name;
    this.advanced_filter_criteria_style = this.CRMAdvancedSearchInfo.advanced_filter_criteria_style;
    this.advanced_filter_criteria_cemetery = this.CRMAdvancedSearchInfo.advanced_filter_criteria_cemetery;
    this.advanced_filter_criteria_section = this.CRMAdvancedSearchInfo.advanced_filter_criteria_section;
    this.advanced_filter_criteria_row = this.CRMAdvancedSearchInfo.advanced_filter_criteria_row;
    this.advanced_filter_criteria_grave = this.CRMAdvancedSearchInfo.advanced_filter_criteria_grave;
    this.advanced_filter_criteria_container = this.CRMAdvancedSearchInfo.advanced_filter_criteria_container;
    this.searchMode = this.CRMAdvancedSearchInfo.searchMode == "" ? "basic" : this.CRMAdvancedSearchInfo.searchMode;

    this.filterCriteria = this.crmOrdersFilterCriteria;
    this.searchbar_content = this.filterCriteria;
    this.tableIsBusy = true;

    if (this.searchMode == 'advanced') {
      this.advanced_search_disabled = false;
      this.tab_index = 1;
      this.advanced_clicked();
    }

    // if (this.user.role == 'admin') {
    //   this.elasticClient
    //     .search("active", {search_fields: { status: {} }, result_fields: this.elasticResultFields})
    //     .then(resultList => {
    //       this.activeOrders = resultList.results.map((doc) => doc.data());
    //     });
    //   } else {
    //     this.elasticClient
    //     .search("active", {search_fields: { status: {} }, result_fields: this.elasticResultFields})
    //     .then(resultList => {
    //       resultList.forEach(resultList => {
    //         resultList.results.forEach(result => {
    //           console.log(result);
    //         });
    //       });
    //     });
    // }

    if (this.user.role == 'admin') {
      firebase
        .firestore()
        .collection("crm_orders_simplified")
        .where('status', '==', 'active')
        .orderBy("invoiceNumber", "asc")
        .onSnapshot((collection) => {
          this.activeOrders = collection.docs.map((doc) => doc.data());
          if (this.searchMode == "basic") {
            this.displayedOrders = this.activeOrders;
          }
          this.advanced_search_disabled = false;
          this.tableIsBusy = false;
          console.log("created");
      });
    } else {
      firebase
        .firestore()
        .collection("crm_orders_simplified")
        .where("salesName", "==", this.user.name)
        .where('status', '==', 'active')
        .orderBy("invoiceNumber", "asc")
        .onSnapshot((collection) => {
          this.activeOrders = collection.docs.map((doc) => doc.data());
          if (this.searchMode == "basic") {
            this.displayedOrders = this.activeOrders;
          }
          this.advanced_search_disabled = false;
          this.tableIsBusy = false;
          console.log("created");
        });
    }

    // firebase
    //   .firestore()
    //   .collection("crm_orders")
    //   .orderBy("invoiceNumber", "asc")
    //   .onSnapshot((collection) => {
    //     this.orders = [];
    //     this.orders = collection.docs.map((doc) => doc.data());
    //   });

    // firebase
    //   .firestore()
    //   .collection("crm_orders")
    //   .where('salesName', '==', this.user.name)
    //   .orderBy("invoiceNumber", "asc")
    //   .onSnapshot((collection) => {
    //     this.myOrders = [];
    //     this.myOrders = collection.docs.map((doc) => doc.data());
    //     console.log(this.myOrders);
    //     this.displayedOrders = this.orders;
    //   });

  },
}
</script>

<style>
.top-row {
  display: flex;
  align-items: center;
}

.top-row-name {
  font-size: 46px;
  font-weight: 500;
}

.top-row-button {
  margin-left: 10px;
}

.table-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 26px;
  max-width: 50px;
}
</style>